import React, { Component } from 'react'
import "./_leadManagement.scss"
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import CardLessDataTableWithSearch from "../../components/datatables/CardLessDataTableWithSearch"
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import "./_leadManagement.scss";
import ScrollMenu from 'react-horizontal-scrolling-menu';
import LeadsModalDetails from './LeadsModalDetails';







const MenuItem = ({ text }) => (
  <div className="menu-item card">
    <div className="card-body card-items">
      <ul >
        <li className="text-center "><h6>{text.count}</h6></li>
        <li className="text-center ">{text.lead_status_type}</li>
      </ul>
    </div>
  </div>
);

export const Menu = (list) =>
  list[0].status_details.map(el => (
    <MenuItem text={el} key={el.lead_status_type} />
  ));

const Arrow = ({ text, className }) => (
  <div className={className}>{text}</div>
);

export const ArrowLeft = Arrow({ text: <i className="fas fa-chevron-left"></i>, className: 'arrow-prev' });
export const ArrowRight = Arrow({ text: <i className="fas fa-chevron-right"></i>, className: 'arrow-next' });



class EmployeeRecords extends Component {
  constructor(props) {
    super(props);
    this.menu = React.createRef();
    this.state = {
      selectedOptionId: "1",
      nextLevelUserAndEmployeeDetails: this.props.getNextLevelUserAndEmployeeDetails,
      nextLevelTotalUsers: this.props.getNextLevelTotalUsers,
      nextLevelEmp: [],
      userLevelArrFromBreadCrumb: [],
      is_grouping: true,
      loader: 0,
      alignCenter: false,
      clickWhenDrag: false,
      hideArrows: false,
      dragging: true,
      hideSingleArrow: true,
      translate: 0,
      transition: 0.4,
      wheel: true,
      inertiascrolling: false,
      slowdownFactor: 0.25,
      leadModalDetails:false,
      rowData: [],

    }
  }

  onUpdate = ({ translate }) => {
    this.setState({ translate });
  };


  nextLevelUserAndEmployeeDetailsHandle = async (val, group, name) => {

    this.setState({ loader: 1 });

    const result = await this.props.client.query({
      query: gql`
        query($institute_id: Int!,$branch_id: Int!,$head_employee_id: Int!,$is_grouping: Boolean!) {
          getNextLevelUserAndEmployeeDetails(institute_id: $institute_id,branch_id: $branch_id,head_employee_id: $head_employee_id,is_grouping: $is_grouping) {
            level_id
            employee_id
            employee_name
            next_level_emp
            status_details
          }
        }
      `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(Cookies.get("branch_id")),
        head_employee_id: parseInt(val),
        is_grouping: group,
      },
      fetchPolicy: 'network-only',
    })

    if (result.data.getNextLevelUserAndEmployeeDetails.length > 0) {
      console.log("group", group);
      let data = result.data.getNextLevelUserAndEmployeeDetails;
      this.setState({ nextLevelUserAndEmployeeDetails: data, loader: 0, nextLevelEmp: data[0].next_level_emp })
    } else {
      this.setState({ loader: 0, nextLevelEmp: 0, })
    }
  }

  breadCumbAdding = (val, group, name) => {

    let breadCumAddingData = [];
    if (this.state.userLevelArrFromBreadCrumb.length > 0) {
      this.state.userLevelArrFromBreadCrumb.map((item) => {
        breadCumAddingData.push({ ...item, is_clicked: true })
      })
    }
    breadCumAddingData.push({ employee_id: val, employee_name: name, is_clicked: false });

    this.setState({ userLevelArrFromBreadCrumb: breadCumAddingData })

    this.nextLevelUserAndEmployeeDetailsHandle(val, group);
  }

  breadCumDeleting = (id, group, level, ind) => {
    if (level == "main") {
      this.setState({ userLevelArrFromBreadCrumb: [] });
      this.nextLevelUserAndEmployeeDetailsHandle(id, group);
    } else {

      let remainingBreadcumb = [];
      this.state.userLevelArrFromBreadCrumb.filter((item, index) => index <= ind).map((item1) => {
        if (item1.employee_id == id) {
          remainingBreadcumb.push({ ...item1, is_clicked: false })
        } else {
          remainingBreadcumb.push(item1)
        }
      })
      this.setState({ userLevelArrFromBreadCrumb: remainingBreadcumb })
      this.nextLevelUserAndEmployeeDetailsHandle(id, group);
    }
  }

  handleInputRadioChange = (selectedOptionId) => {
    this.setState({ selectedOptionId, nextLevelUserAndEmployeeDetails: this.props.getNextLevelUserAndEmployeeDetails, userLevelArrFromBreadCrumb: [] });
  };


  columnsFun() {

    let articlecolumns = [
      {
        dataField: "employee_name",
        text: "Employee Name",
        sort: true,
      },
    ];


    if (this.state.nextLevelTotalUsers.length > 0) {
      this.state.nextLevelTotalUsers[0].status_details.map((item) => {
        if (item.lead_status_type != "Total Users") {
          articlecolumns.push({
            dataField: item.lead_status_type.replace(" ", "_"),
            text: item.lead_status_type,
            sort: true,
            formatter: this.leadModal.bind(this)
          })
        }
      })
    }

    return articlecolumns
  }


  leadModal(val, row) {
    console.log("numberrrrrr", row, val)
    return (<>
      <div>
        {
          val.length != 0 ? (
            <a href="#" onClick={() => { this.setState({ leadModalDetails: true, rowData: val }) }}>
              {val.length}
            </a>
          ) : (val.length)
        }
      </div>
    </>)

  }

  tableData(data) {
    let columns = data[0].lead_details.map((item) => item.lead_status_type.replace(" ", "_"));
    console.log("data123", columns, data[0].lead_details)
    let returnData = [];
    data.map((item) => {
      const newObj = {
        employee_name: item.employee_name,
      }

      let dynamicFields = []
      columns.map((item1) => {
        console.log("sss", item1);
        let filedData = item.lead_details.filter((item2) => item2.lead_status_type.replace(" ", "_") == item1);
        console.log("filedData", filedData, item1)
        if (filedData.length > 0) {
          dynamicFields.push({ [item1]: filedData[0].details })
        } else {

          dynamicFields.push({ [item1]: filedData })
        }
      })

      dynamicFields.forEach((field) => {
        const fieldName = Object.keys(field);
        newObj[fieldName] = field[fieldName];
      });

      console.log("dynamicData", dynamicFields);

      returnData.push(newObj);
    });
    return returnData;
  }


  columnsFunc2() {

    let articlecolumns1 = [
      {
        dataField: "employee_name",
        text: "Employee Name - (Next Level Count)",
        sort: true,
        formatter: this.nextLevelFunc.bind(this)
      }
    ];

    if (this.state.nextLevelUserAndEmployeeDetails.length > 0) {
      this.state.nextLevelUserAndEmployeeDetails[0].status_details.map((item) => {
        console.log("ggdfdgd", item.status_count)
        articlecolumns1.push({
          dataField: item.lead_status_type.replace(" ", "_"),
          text: item.lead_status_type,
          sort: true,
          formatter: this.leadModal.bind(this)
        })
      })
    }

    return articlecolumns1
  }

  tableData2(data) {
    let columns = data[0].status_details.map((item) => item.lead_status_type.replace(" ", "_"));

    let returnData = [];
    data.map((item) => {
      const newObj = {
        employee_name: item.employee_name,
      }

      let dynamicData = []
      columns.map((item1) => {
        let filedData = item.status_details.filter((item2) => item2.lead_status_type.replace(" ", "_") == item1);
        if (filedData.length > 0) {
          dynamicData.push({ [item1]: filedData[0].lead_details })
        } else {

          dynamicData.push({ [item1]: filedData })
        }
      })


      dynamicData.forEach((field) => {
        const fieldName = Object.keys(field);
        newObj[fieldName] = field[fieldName];
      });


      returnData.push(newObj);
      console.log("hgfbvb", newObj)
    });
    return returnData;
  }

  nextLevelFunc(val) {
    console.log("hhhnbvhg", val)
    let emp_data = this.state.nextLevelUserAndEmployeeDetails.find((item) => item.employee_name == val)
    console.log("hhhnbvhg", emp_data)
    return (<>
      <div>
        {
          emp_data.next_level_emp > 0 ? (
            <>
              <a href="#" onClick={() => { this.breadCumbAdding(emp_data.employee_id, false, val) }}>
                {val}
              </a> &nbsp; -  <span className='ml-2'>({emp_data.next_level_emp})</span>
            </>) : (
            <>
              <span>{val}</span> &nbsp; -   <span className='ml-2'>({emp_data.next_level_emp})</span>
            </>
          )

        }
      </div>
    </>)
  }

  render() {
    console.log("proooteeeee", this.state);

    const { alignCenter, clickWhenDrag, hideArrows, dragging, hideSingleArrow, translate, transition, wheel, inertiascrolling, slowdownFactor } = this.state;

    const menu = Menu(this.state.nextLevelTotalUsers);
    return (
      <section>
        <Container>
          <div className='mb-4 '>
            <ScrollMenu
              alignCenter={alignCenter}
              arrowLeft={ArrowLeft}
              arrowRight={ArrowRight}
              data={menu}
              dragging={dragging}
              hideArrows={hideArrows}
              hideSingleArrow={hideSingleArrow}
              inertiaScrolling={inertiascrolling}
              inertiaScrollingSlowdown={slowdownFactor}
              ref={this.menu}
              rtl={false}
              scrollBy={0}
              transition={+transition}
              translate={translate}
              useButtonRole={true}
              wheel={wheel}
              onUpdate={this.onUpdate}

            />          </div>

          {
            this.state.nextLevelTotalUsers.length > 0 ?
              (
                <>
                  <Row className='mt-4'>
                    <Col sm={11}>
                      <div className='text-right'>
                        <Form.Check type="radio" name="radioOption" id="1" label="Individual User" className="mr-3  RadioButtons h6" onClick={() => { this.handleInputRadioChange("1") }} checked={this.state.selectedOptionId == "1"} style={{ cursor: "pointer" }} />
                        <Form.Check type="radio" name="radioOption" id="2" label="Level Wise User" className='RadioButtons2 h6' onClick={() => { this.handleInputRadioChange("2") }} style={{ cursor: "pointer" }} />
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )
          }
          {
            <Row className='mt-4'>
              {
                this.state.selectedOptionId == "1" ? (
                  <Col lg={12} md={12} sm={12}>
                    {
                      this.state.nextLevelTotalUsers.length > 0 ? (
                        <Card className="table-border">
                          <Card.Body>
                            <CardLessDataTableWithSearch
                              parentData={this.tableData(this.state.nextLevelTotalUsers[0].total_users_details)}
                              particlecolumns={this.columnsFun()}
                              name="attendance"
                            />
                          </Card.Body>
                        </Card>
                      ) : (
                        <Row>
                          <Col ls={12} md={12} sm={12}>
                            <h4 className='no_emp_data'>No data available</h4>
                          </Col>
                        </Row>
                      )
                    }
                  </Col>
                ) : (
                  <Col sm={12}>
                    <div className='my-1'>
                      <ul className="list-inline breadcrumb-nav">
                        <li onClick={() => { this.breadCumDeleting(parseInt(Cookies.get("id")), false, "main") }}><i className="fas fa-home" /><i className=' ml-2' /></li>
                        {
                          this.state.userLevelArrFromBreadCrumb.length > 0 ? (<i className='fas fa-chevron-circle-right ml-2'></i>) : ("")
                        }
                        {
                          this.state.userLevelArrFromBreadCrumb.map((item, index) => {
                            return (
                              item.is_clicked ? (

                                <li onClick={() => { this.breadCumDeleting(item.employee_id, false, "sub", index) }}>{item.employee_name}<i className='fas fa-chevron-circle-right ml-2'></i></li>
                              ) : (
                                <li className='color_black'>{item.employee_name}</li>
                              )
                            )
                          })
                        }
                      </ul>
                    </div>
                    <Card className="table-border">
                      <Card.Body>
                        {
                          this.state.loader == 1 ? (
                            <Row className="my-2">
                              <Col>
                                <div className="spinner-border text-primary text-center loading-img-center"></div>
                              </Col>
                            </Row>
                          ) : (
                            <CardLessDataTableWithSearch
                              parentData={this.tableData2(this.state.nextLevelUserAndEmployeeDetails)}
                              particlecolumns={this.columnsFunc2()}
                              name="attendance"
                            />
                          )
                        }
                      </Card.Body>
                    </Card>
                  </Col>)
              }
            </Row>
          }


          <LeadsModalDetails
            stateData={this.state}
            show={this.state.leadModalDetails}
            onHide={() => this.setState({ leadModalDetails: false })}
          />
        </Container>
      </section>
    )
  }
}

export default withRouter(withApollo(compose(

)(EmployeeRecords))
);